/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { PropsWithChildren } from "react";
import { Text } from "@nordcloud/gnui";
import { CloudResourceProvider } from "~/generated/graphql";
import { Detail } from "./Details/Detail";

type Props = PropsWithChildren<{
  to: string;
  provider?: CloudResourceProvider;
  type?: string;
  subtype?: string;
}>;

export function NameCell({ to, provider, children, type, subtype }: Props) {
  return (
    <div title={children as string}>
      <Detail
        detail={{
          label: undefined,
          value: children as string,
          clipboard: true,
          link: to,
        }}
      />

      {provider && (
        <Text tag="div" size="sm">
          {`${type ?? "Unknown Type"}/${subtype ?? "Unknown Subtype"}`}
        </Text>
      )}
    </div>
  );
}
